// LocationPermissionModal.js
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import CustomText, { textStyles } from "../../../../components/CustomText";
import warning from "../../../../assets/warning.svg";

const LocationPermissionModal = ({ open, onCancel, onAllow, onRefresh }) => {
  const { t } = useTranslation();
  // Refresh handler
  const handleRefresh = () => {
    const retry = onAllow || onRefresh;
    if (retry) {
      retry();
      return;
    }
    window.location.reload();
  };
  

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      onClose={onCancel}
      PaperProps={{
        sx: {
          px: 1,
          py: 2,
          borderRadius: "12px", // more rounded corners
        },
      }}
    >
        <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",mb:1}}>
        <img src={warning} style={{width:50,height:50}}/>
        </Box>
      {/* Title */}
      <CustomText
        sx={{
          ...textStyles.h1,
          fontSize: 18,
          fontWeight: 600,
          color: "#2C384C",
          mb: 2,
          pt:0.5,
        }}
      >
       {t("Turn on location to continue")}
      </CustomText>

      <DialogContent dividers>


        {/* Desktop Instructions */}
        <Box sx={{ mb: 3 }}>
       
          <CustomText sx={{ fontSize: 12, color: "#172B4D", mb: 1 ,          fontFamily: 'Poppins, sans-serif',
}}>
            <strong>{t("Chrome/Edge:")}</strong>  {" "}{t("Click the padlock icon in the address bar →  Site settings → Location → Allow, then reload.")}
          </CustomText>
          <CustomText sx={{ fontSize: 12, color: "#172B4D", mb: 1,          fontFamily: 'Poppins, sans-serif',
 }}>
            <strong>{t("Firefox:")}</strong>  {" "}{t("Click the shield/info icon → Permissions →  Location → Allow, then reload.")}
          </CustomText>
          <CustomText sx={{ fontSize: 12, color: "#172B4D",          fontFamily: 'Poppins, sans-serif',
 }}>
            <strong>{t("Safari (macOS):")}</strong> {" "}{t("Safari Settings → Websites → Location →  Allow, then reload.")}
          </CustomText>
        </Box>

     
      </DialogContent>


                <Box sx={{ mt: 2, mb:0.5, display: 'flex',flexWrap:"wrap", justifyContent:"flex-end", gap: 2 }}>
        <CustomButton
         onClick={handleRefresh}
          label={t("I’ve enabled it")}
          size="medium"
        />
      
        <Button
          variant="outlined"
       onClick={onCancel}
          sx={{
            fontSize: 15,
            textTransform: 'none',
            borderRadius: '5px',
            fontFamily: 'Poppins, sans-serif',
            color: '#006EC2',
            border: "2px solid #006EC2",
            px: 3,
            py: 1,
            height: 'fit-content',
          }}
        >
              {t("Cancel")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default LocationPermissionModal;
